import { cn } from "@/lib/utils";

/**
 * Serpix wordmark: violet gradient "S" mark + Sora wordmark.
 * Sizes: sm (auth pages), md (nav), lg (hero/footer).
 */
export function SerpixWordmark({ size = "md", className = "", withText = true, hideTextOnMobile = false }) {
  const dims = {
    sm: { mark: "h-8 w-8 text-base", text: "text-lg" },
    md: { mark: "h-9 w-9 text-lg", text: "text-xl" },
    lg: { mark: "h-11 w-11 text-xl", text: "text-2xl" },
  }[size];

  return (
    <span className={cn("inline-flex items-center gap-2.5", className)}>
      <span
        className={cn(
          "flex flex-none items-center justify-center rounded-xl font-display font-bold text-white shadow-lg shadow-violet-500/25",
          "bg-gradient-to-br from-[#5B4CFB] via-[#7c5cf6] to-[#EC4899]",
          dims.mark
        )}
        aria-hidden="true"
      >
        S
      </span>
      {withText && (
        <span
          className={cn(
            "font-display font-bold tracking-tight text-zinc-900",
            dims.text,
            hideTextOnMobile && "hidden sm:inline"
          )}
        >
          Serpix
        </span>
      )}
    </span>
  );
}
